import React from 'react';
import { AudioPlayerContextType } from './types';

const AudioPlayerContext = React.createContext<
  AudioPlayerContextType | undefined
>(undefined);

export default AudioPlayerContext;
